import { DraggableItemProps } from './DraggableItem.jsx';

export const getCursorStyle = ({
  isDragged,
  disabled,
}: Partial<DraggableItemProps>) => {
  if (isDragged) {
    return 'grabbing';
  }
  if (disabled) {
    return 'not-allowed';
  }
  return 'pointer';
};

export const getBoxShadow = ({
  isDragged,
  disabled,
}: Partial<DraggableItemProps>) => {
  if (disabled) {
    return 'none';
  }
  if (isDragged) {
    return '0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)';
  }
  return '0px 1px 2px 0px rgba(16, 24, 40, 0.05)';
};
